import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Upis() {
  const [t] = useTranslation();

  return (
    <>
      <div className="admissions-page">
        <div className="container mt-4 pt-40">
          {/* HERO */}
          <section
            className="admissions-hero"
            aria-label={t("admissionsPage.upis.heroTitle")}
          >
            <div className="admissions-hero__inner">
              <div className="admissions-hero__copy">
                <div className="admissions-eyebrow">
                  {t("admissionsPage.eyebrow")}
                </div>
                <h1 className="admissions-hero__title">
                  {t("admissionsPage.upis.heroTitle")}
                </h1>
                <p className="admissions-hero__subtitle">
                  {t("admissionsPage.upis.heroSubtitle")}
                </p>

                <div className="admissions-hero__cta">
                  <Link
                    className="admissions-btn admissions-btn--primary"
                    to="/upisni-rokovi"
                  >
                    {t("admissionsPage.cta.konkurs")}
                    <i className="fas fa-long-arrow-alt-right" />
                  </Link>
                  <Link
                    className="admissions-btn admissions-btn--secondary"
                    to="/svi-studijski-programi"
                  >
                    {t("admissionsPage.cta.programs")}
                    <i className="fas fa-long-arrow-alt-right" />
                  </Link>
                  <a
                    className="admissions-btn admissions-btn--ghost"
                    href="mailto:fpebar@gmail.com"
                  >
                    {t("admissionsPage.cta.email")}
                  </a>
                </div>

                <div className="admissions-quickfacts">
                  <div className="admissions-chip">
                    {t("admissionsPage.quickfacts.textbooks")}
                  </div>
                  <div className="admissions-chip">
                    {t("admissionsPage.quickfacts.platform")}
                  </div>
                  <div className="admissions-chip">
                    {t("admissionsPage.quickfacts.practice")}
                  </div>
                  <div className="admissions-chip">
                    {t("admissionsPage.quickfacts.erasmus")}
                  </div>
                </div>
              </div>

              <div
                className="admissions-hero__panel"
                aria-label={t("admissionsPage.upis.panelTitle")}
              >
                <div className="admissions-panel__title">
                  {t("admissionsPage.upis.panelTitle")}
                </div>

                <div className="admissions-steps">
                  <div className="admissions-step">
                    <div className="admissions-step__num">1</div>
                    <div className="admissions-step__body">
                      <div className="admissions-step__title">
                        {t("admissionsPage.steps.s1.title")}
                      </div>
                      <div className="admissions-step__text">
                        <Link to="/svi-studijski-programi">
                          {t("admissionsPage.steps.s1.link")}
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="admissions-step">
                    <div className="admissions-step__num">2</div>
                    <div className="admissions-step__body">
                      <div className="admissions-step__title">
                        {t("admissionsPage.steps.s2.title")}
                      </div>
                      <div className="admissions-step__text">
                        <Link to="/upisni-rokovi">
                          {t("admissionsPage.steps.s2.link")}
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="admissions-step">
                    <div className="admissions-step__num">3</div>
                    <div className="admissions-step__body">
                      <div className="admissions-step__title">
                        {t("admissionsPage.steps.s3.title")}
                      </div>
                      <div className="admissions-step__text">
                        <a href="#dokumenta-upis">
                          {t("admissionsPage.steps.s3.link")}
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="admissions-step">
                    <div className="admissions-step__num">4</div>
                    <div className="admissions-step__body">
                      <div className="admissions-step__title">
                        {t("admissionsPage.steps.s4.title")}
                      </div>
                      <div className="admissions-step__text">
                        <a href="#kontakt">
                          {t("admissionsPage.steps.s4.link")}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="admissions-panel__actions">
                  <a
                    className="admissions-btn admissions-btn--mini"
                    href="tel:+38268003113"
                  >
                    {t("admissionsPage.cta.call")} +382 68 003 113
                  </a>
                  <a
                    className="admissions-btn admissions-btn--mini"
                    href="tel:+38268011311"
                  >
                    {t("admissionsPage.cta.call")} +382 68 011 311
                  </a>
                </div>
              </div>
            </div>
          </section>

          {/* LAYOUT */}
          <div className="row admissions-layout">
            <div className="col-md-8">
              <div className="content-container admissions-content">
                <nav
                  className="admissions-anchor"
                  aria-label={t("admissionsPage.nav.aria")}
                >
                  <a href="#kako">{t("admissionsPage.nav.how")}</a>
                  <a href="#kandidat">{t("admissionsPage.nav.about")}</a>
                  <a href="#dokumenta-upis">
                    {t("admissionsPage.nav.documents")}
                  </a>
                  <a href="#priznavanje">
                    {t("admissionsPage.nav.recognition")}
                  </a>
                  <a href="#pitanja">{t("admissionsPage.nav.faq")}</a>
                  <a href="#kontakt">{t("admissionsPage.nav.contact")}</a>
                </nav>

                {/* ABOUT */}
                <section id="kandidat" className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.upis.sectionIntroTitle")}
                  </h2>
                  <p className="admissions-lead">
                    {t("upis.p1")}{" "}
                    <Link to="/upisni-rokovi">
                      <strong>{t("upis.p2")}</strong>
                    </Link>{" "}
                    {t("upis.p3")}
                  </p>

                  <div className="admissions-linkgrid">
                    <Link
                      className="admissions-linkcard"
                      to="/svi-studijski-programi"
                    >
                      <div className="admissions-linkcard__title">
                        {t("upis.proglink")}
                      </div>
                      <div className="admissions-linkcard__text">
                        {t("admissionsPage.upis.programsHint")}
                      </div>
                      <i className="fas fa-long-arrow-alt-right" />
                    </Link>

                    <Link className="admissions-linkcard" to="/upisni-rokovi">
                      <div className="admissions-linkcard__title">
                        {t("upis.konklink")}
                      </div>
                      <div className="admissions-linkcard__text">
                        {t("admissionsPage.upis.konkursHint")}
                      </div>
                      <i className="fas fa-long-arrow-alt-right" />
                    </Link>
                  </div>
                </section>

                {/* RULES / SUPPORT */}
                <section id="kako" className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.upis.sectionRulesTitle")}
                  </h2>
                  <p className="admissions-prose">{t("upis.p4")}</p>
                </section>

                <section className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.upis.sectionProgressTitle")}
                  </h2>
                  <p className="admissions-prose">{t("upis.p5")}</p>
                </section>

                {/* DOCUMENTS (GENERAL ENROLLMENT) */}
                <section id="dokumenta-upis" className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("upis.docsNeededTitle")}
                  </h2>
                  <p className="admissions-prose">{t("upis.docsNeededLead")}</p>

                  <div className="admissions-docgrid">
                    <div className="admissions-doccard">
                      <div
                        className="admissions-doccard__icon"
                        aria-hidden="true"
                      >
                        <i className="fas fa-graduation-cap" />
                      </div>
                      <div className="admissions-doccard__title">
                        {t("upis.docsNeeded1")}
                      </div>
                    </div>

                    <div className="admissions-doccard">
                      <div
                        className="admissions-doccard__icon"
                        aria-hidden="true"
                      >
                        <i className="fas fa-file-alt" />
                      </div>
                      <div className="admissions-doccard__title">
                        {t("upis.docsNeeded2")}
                      </div>
                    </div>

                    <div className="admissions-doccard">
                      <div
                        className="admissions-doccard__icon"
                        aria-hidden="true"
                      >
                        <i className="fas fa-camera" />
                      </div>
                      <div className="admissions-doccard__title">
                        {t("upis.docsNeeded3")}
                      </div>
                    </div>

                    <div className="admissions-doccard">
                      <div
                        className="admissions-doccard__icon"
                        aria-hidden="true"
                      >
                        <i className="fas fa-id-card" />
                      </div>
                      <div className="admissions-doccard__title">
                        {t("upis.docsNeeded4")}
                      </div>
                    </div>
                  </div>

                  {/* FOREIGN (ONLY IF NEEDED) */}
                  <details
                    className="admissions-details"
                    id="dokumenta-inostrano"
                  >
                    <summary className="admissions-details__summary">
                      <span>{t("upis.docsForeignToggle")}</span>
                      <i
                        className="fas fa-chevron-down admissions-details__chev"
                        aria-hidden="true"
                      />
                    </summary>

                    <div className="admissions-callout admissions-callout--nested">
                      <h3 className="admissions-section__subtitle">
                        {t("upis.p10")}
                      </h3>
                      <ul className="admissions-list">
                        <li>{t("upis.l1")}</li>
                        <li>{t("upis.l2")}</li>
                        <li>{t("upis.l3")}</li>
                        <li>{t("upis.l4")}</li>
                        <li>{t("upis.l5")}</li>
                      </ul>
                    </div>
                  </details>
                </section>

                {/* RECOGNITION */}
                <section id="priznavanje" className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.upis.sectionRecognitionTitle")}
                  </h2>
                  <p className="admissions-prose">{t("upis.p6")}</p>
                  <p className="admissions-prose">{t("upis.p7")}</p>
                </section>

                {/* RECORDS / DIPLOMAS */}
                <section className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.upis.sectionRecordsTitle")}
                  </h2>
                  <p className="admissions-prose">{t("upis.p8")}</p>
                </section>

                <section className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.upis.sectionDiplomasTitle")}
                  </h2>
                  <p className="admissions-prose">{t("upis.p9")}</p>
                </section>

                {/* FAQ */}
                <section id="pitanja" className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.faq.title")}
                  </h2>
                  <div className="admissions-faq">
                    <details>
                      <summary>{t("admissionsPage.faq.q1")}</summary>
                      <div className="admissions-faq__body">
                        {t("admissionsPage.faq.a1")}
                      </div>
                    </details>
                    <details>
                      <summary>{t("admissionsPage.faq.q2")}</summary>
                      <div className="admissions-faq__body">
                        {t("admissionsPage.faq.a2")}
                      </div>
                    </details>
                    <details>
                      <summary>{t("admissionsPage.faq.q3")}</summary>
                      <div className="admissions-faq__body">
                        {t("admissionsPage.faq.a3")}
                      </div>
                    </details>
                    <details>
                      <summary>{t("admissionsPage.faq.q4")}</summary>
                      <div className="admissions-faq__body">
                        {t("admissionsPage.faq.a4")}
                      </div>
                    </details>
                  </div>
                </section>

                {/* CONTACT */}
                <section id="kontakt" className="admissions-section">
                  <h2 className="admissions-section__title">
                    {t("admissionsPage.contact.title")}
                  </h2>
                  <div className="admissions-contactgrid">
                    <div className="admissions-contactcard">
                      <div className="admissions-contactcard__k">
                        {t("admissionsPage.contact.locationLabel")}
                      </div>
                      <div className="admissions-contactcard__v">
                        {t("admissionsPage.contact.locationValue")}
                      </div>
                    </div>
                    <div className="admissions-contactcard">
                      <div className="admissions-contactcard__k">
                        {t("admissionsPage.contact.phoneLabel")}
                      </div>
                      <div className="admissions-contactcard__v">
                        <a href="tel:+38268003113">068/003-113</a> ·{" "}
                        <a href="tel:+38268011311">068/011-311</a>
                      </div>
                    </div>
                    <div className="admissions-contactcard">
                      <div className="admissions-contactcard__k">
                        {t("admissionsPage.contact.emailLabel")}
                      </div>
                      <div className="admissions-contactcard__v">
                        <a href="mailto:fpebar@gmail.com">fpebar@gmail.com</a>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            {/* SIDEBAR */}
            <div className="col-md-4 pt-10">
              <aside className="sidebar-widget admissions-sidebar">
                <section className="admissions-asidecard">
                  <div className="admissions-asidecard__title">
                    {t("admissionsPage.sidebar.title")}
                  </div>
                  <div className="admissions-asidecard__text">
                    {t("admissionsPage.sidebar.text")}
                  </div>
                  <div className="admissions-asidecard__actions">
                    <Link
                      className="admissions-btn admissions-btn--primary admissions-btn--block"
                      to="/upisni-rokovi"
                    >
                      {t("admissionsPage.cta.konkurs")}
                      <i className="fas fa-long-arrow-alt-right" />
                    </Link>
                    <Link
                      className="admissions-btn admissions-btn--secondary admissions-btn--block"
                      to="/cijene-studija"
                    >
                      {t("admissionsPage.cta.tuition")}
                      <i className="fas fa-long-arrow-alt-right" />
                    </Link>
                  </div>
                </section>

                {/* tvoji postojeći widgeti (ostavi kako jesu) */}

                <section
                  id="custom_html-5"
                  className="widget_text widget widget_custom_html"
                >
                  <h2 className="widget-title">{t("sidebar.follow")}</h2>
                  <div className="textwidget custom-html-widget">
                    <div className="widget-social">
                      <a
                        href="https://www.facebook.com/fpebar.me"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Facebook"
                      >
                        <i className="fab fa-facebook-f" />
                      </a>
                      <a
                        href="https://www.instagram.com/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Instagram"
                      >
                        <i className="fab fa-instagram" />
                      </a>
                      <a
                        href="https://www.youtube.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-youtube" />
                      </a>
                      <a
                        href="https://www.tiktok.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on Tiktok"
                        title="Tiktok"
                      >
                        <i className="fab fa-tiktok" />
                      </a>
                      <a
                        href="https://www.linkedin.com/school/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on LinkedIn"
                        title="LinkedIn"
                      >
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </div>
                  </div>
                </section>
                <section id="categories-1" className="widget widget_categories">
                  <h2 className="widget-title">{t("sidebar.useful")}</h2>
                  <ul>
                    <li className="cat-item cat-item-16">
                      <Link to="/o-fpep">{t("about.fpep")}</Link>
                    </li>
                    <li className="cat-item cat-item-23">
                      <Link to="/akreditacija-fpep">
                        {t("admission.Akreditacija")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-18">
                      <Link to="/upis">{t("upis.title")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/cijene-studija">
                        {t("admission.Skolarina")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/projekti">{t("saradnja.projekti")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/galerija">{t("navbar.Gallery")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/novosti">{t("navbar.News")}</Link>
                    </li>
                  </ul>
                </section>
                <section
                  id="recent-posts-4"
                  className="widget widget_recent_entries"
                >
                  <h2 className="widget-title">{t("sidebar.study")}</h2>
                  <ul>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.osnovne")}</strong> <br />
                      </span>
                      <Link to="/racunovodstvo-finansije-i-bankarstvo">
                        {t("osnovne.rfb")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment">
                        {t("osnovne.menadzment")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-osnovne">
                        {t("osnovne.pravo")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.master")}</strong> <br />
                      </span>
                      <Link to="/poslovna-ekonomija">
                        {t("master.poslovnaEkonomija")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/ekonomija-javnog-sektora">
                        {t("master.ekonomijaJavnogSektora")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-master">
                        {t("master.pravo")}
                        <br />
                      </Link>
                    </li>

                    <li>
                      <span className="post-date">
                        <strong>{t("programs.specijalisticke")}</strong> <br />
                      </span>
                      <Link to="/menadzment-javnog-sektora-specijalisticke">
                        {t("specijalisticke.mjs")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment-profitnog-sektora-specijalisticke">
                        {t("specijalisticke.mps")}
                        <br />
                      </Link>
                    </li>
                  </ul>
                </section>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Upis;
